import { Divider, Paper } from '@mui/material';
import { ILastClaimEventEntries } from 'API';
import { useIsDesktop } from 'Hooks';
import { GeneralData } from 'Modules/Status/Sections/SectionItem/GeneralData';
import { StageAndMoreInfo } from 'Modules/Status/Sections/SectionItem/StageAndMoreInfo';

interface IClaimEvent {
  claimEvent: ILastClaimEventEntries;
}

export const ClaimEvent = ({ claimEvent }: IClaimEvent) => {
  const isDesktop = useIsDesktop();

  return (
    <Paper
      sx={{
        width: '100%',
        maxWidth: '598px',
        borderRadius: '16px',
        border: '1px solid #E7EDFF',
        bgcolor: '#FFF',
        padding: isDesktop ? '24px 24px 32px 24px' : '24px 24px 54px 24px',
        boxShadow: 'none',
        position: isDesktop ? undefined : 'relative',
      }}
    >
      <GeneralData
        matter={claimEvent.pgimaDescription}
        treatmentStage={{
          stepId: claimEvent.statusType,
          decisionType: claimEvent.decisionType,
          isCurrentStep: true,
        }}
        updateDate={claimEvent.statusDate}
      />

      {isDesktop && (
        <Divider sx={{ margin: '24px 0', borderColor: 'primary.shade_100' }} />
      )}
      <StageAndMoreInfo
        stepsAmount={6}
        currentStep={claimEvent.statusType}
        claimEventNumber={claimEvent.pgimaNumber}
      />
    </Paper>
  );
};
